namespace TabAurous.Stock {
    export namespace MetalService {
        export const baseUrl = 'Stock/StockMetal';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function KaratList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ColorList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/StockMetal/List",
            KaratList = "Stock/StockMetal/KaratList",
            ColorList = "Stock/StockMetal/ColorList"
        }

        [
            'List', 
            'KaratList', 
            'ColorList'
        ].forEach(x => {
            (<any>MetalService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
